import { SOCIAL_ACTION_PRODUCT_CHROME as socialChrome } from './socialActionPresentation';

/**
 * Thin depth-1 quote embed. Non-interactive (no like/comment/save/share on source).
 */
export default function SocialQuoteReferenceCard({ quote, className = '' }) {
  if (!quote) return null;
  const rootClass = ['social-quote-ref', className].filter(Boolean).join(' ');
  if (!quote.available) {
    return (
      <div className={`${rootClass} social-quote-ref--unavailable`} aria-label={socialChrome.quoteUnavailableAria}>
        <strong>{socialChrome.quoteUnavailableTitle}</strong>
        <p>{socialChrome.quoteUnavailableBody}</p>
      </div>
    );
  }
  return (
    <div className={rootClass} aria-label={socialChrome.quotePreviewAria}>
      <small>{socialChrome.quoteFromLabel(quote.authorName)}</small>
      {quote.text ? <p>{quote.text}</p> : <p>{socialChrome.quoteEmptyPreview}</p>}
    </div>
  );
}
